import { format } from 'date-fns'
import itLocale from 'date-fns/locale/it'

export const insertMessagesInItems = (messages, items, attribute = 'plate') => {
  for (let i = 0; i < messages.length; i++) {
    const message = messages[i]
    const item = items.find((item) => item[attribute] === message[attribute])
    if (!item) {
      continue
    }
    item.messages ? item.messages.push(message) : (item.messages = [message])
  }
}

export const mapMessagesForDownload = (messages, t, admin) => {
  return messages.reduce((previous, message) => {
    const partner = admin
      ? `, ${t('common.excel.partner')}: ${message.partnerId}`
      : ''
    return `${previous}${format(
      new Date(message.createdAt),
      t('common.date.format'),
      {
        locale: itLocale,
      }
    )}${partner}
${message.message}

`
  }, '')
}
